import { render, staticRenderFns } from "./UnderwriterMenu.vue?vue&type=template&id=725f6f91"
import script from "./UnderwriterMenu.vue?vue&type=script&lang=js"
export * from "./UnderwriterMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports